import { render, staticRenderFns } from "./ImportarXmlAditivoContrato.vue?vue&type=template&id=4985eeb8"
import script from "./ImportarXmlAditivoContrato.vue?vue&type=script&lang=ts"
export * from "./ImportarXmlAditivoContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports